import React from 'react';
import { ErrorPage } from '@zg-rentals/visual-cohesion';
import { Box } from '@zillow/constellation-10';
import STRING_CONSTANTS from 'app/shared/constants/StringConstants';
import { getZillowUrl } from 'app/shared/utils/urlUtils';

const NotFoundPage = () => (
  <Box css={{ height: '100vh', width: '100%', backgroundColor: 'bg.screen.neutral' }}>
    <ErrorPage
      errorMessage={STRING_CONSTANTS.NOT_FOUND_ERROR_MESSAGE}
      errorDetails={STRING_CONSTANTS.NOT_FOUND_ERROR_DETAILS}
      action={<a href={getZillowUrl('/rental-manager/')}>Go to Rental Manager</a>}
    />
  </Box>
);

export default NotFoundPage;
